import { gql } from "config/graphql";
import { Health, ISO8601Date, MutationResponse, SuccessResponse, TermUnit } from "config/types";
import { getApolloClient } from "store/apollo";
import { assertDefined } from "utils/error";

export interface IUpdateEstimateDatumInput {
  termUnit: TermUnit;
  termDuration: number;
  amount: number;
}

interface IUpdateEstimateDatumData {
  updateEstimateDatum: {
    estimate: {
      annualPremium: number;
      monthlyPremium: number;
      allocationsCoveredPercentage: number;
    };
  };
}

export const updateEstimationDatumMutation: MutationResponse<
  IUpdateEstimateDatumInput,
  IUpdateEstimateDatumData
> = async (estimate: IUpdateEstimateDatumInput) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation updateEstimate($input: UpdateEstimateDatumInput!) {
      updateEstimateDatum(input: $input) {
        estimate {
          annualPremium
          monthlyPremium
          allocationsCoveredPercentage
        }
      }
    }
  `;

  const { data } = await client.mutate<IUpdateEstimateDatumData>({
    variables: {
      input: estimate,
    },
    mutation,
  });
  return { data: assertDefined(data) };
};

export interface UpdatePrequalificationInformationInput {
  birthdate: ISO8601Date;
  gender: string;
  health: Health | "tobacco";
  desiredCoverageAmount?: string;
  state?: string | null;
}

interface IUpdatePrequalificationInformationData {
  updatePrequalificationInformation: SuccessResponse<{ status: string }>;
}

export const updatePrequalificationInformationMutation: MutationResponse<
  UpdatePrequalificationInformationInput,
  IUpdatePrequalificationInformationData
> = async (input: UpdatePrequalificationInformationInput) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation UpdatePrequalificationInformation($input: UpdatePrequalificationInformationInput!) {
      updatePrequalificationInformation(input: $input) {
        response {
          status
          success
        }
      }
    }
  `;

  const { data } = await client.mutate<IUpdatePrequalificationInformationData>({
    variables: {
      input,
    },
    mutation,
  });
  return { data: assertDefined(data) };
};
